import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentChangesPublishedLogEvent = unifiedAgentEvent<{
  agent_id: number
}>('Unified_Agent_Changes_Published')
